/*
 * @Author: cxy
 * @Desc:
 * @Date: 2024-04-26 10:01:21
 * @LastEditTime: 2024-04-26 10:01:35
 */
import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 地图标签
    WEBSITE_MAP_CATEGORY: computed(() => (
      store.state.label.data.WEBSITE.WEBSITE_MAP_CATEGORY
    ))
  }

  function showName(type, id) {
    const item = computedData[type].value.filter(item => item.key === id)[0]
    return (item && item.value) || '--'
  }

  return {
    ...computedData,
    showName
  }
}
